import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail, Eye, EyeOff } from 'lucide-react';

export default function LoginPage() {
    const navigate = useNavigate();
    const [email, setEmail]       = useState('');
    const [password, setPassword] = useState('');
    const [showPass, setShowPass] = useState(false);
    const [error, setError]       = useState('');
    const [loading, setLoading]   = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const res  = await fetch('/api/auth/login', {
                method:      'POST',
                headers:     { 'Content-Type': 'application/json' },
                credentials: 'include',   // Required — sends/receives cookies
                body:        JSON.stringify({ email, password }),
            });
            const data = await res.json();

            if (!res.ok) {
                setError(data.message || 'Login failed');
                return;
            }

            // Token is in httpOnly cookie — we only get role+name
            localStorage.setItem('trf_role', data.role);
            localStorage.setItem('trf_name', data.name);

            navigate(data.role === 'desk' ? '/desk' : '/doctor');
        } catch {
            setError('Network error — please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="app" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'var(--off-white)' }}>
            <div style={{ width: '100%', maxWidth: '420px', padding: '1rem' }}>
                <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                    <div className="trf-header-logo-text" style={{ background: 'none', padding: 0, fontSize: '1.6rem', color: 'var(--navy)' }}>
                        <span style={{ color: 'var(--navy)' }}>Titanium</span>{' '}
                        <span style={{ color: 'var(--teal)' }}>Surgical Arts</span>
                    </div>
                    <p style={{ color: 'var(--text-muted)', marginTop: '0.4rem', fontSize: '0.85rem', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
                        Staff Portal
                    </p>
                </div>

                <div className="trf-card">
                    <h2 className="trf-section-title" style={{ justifyContent: 'center', borderBottom: 'none', marginBottom: '1.5rem', fontSize: '0.8rem' }}>
                        <Lock size={13} /> Sign In to Your Account
                    </h2>

                    <form onSubmit={handleLogin} noValidate>
                        <div style={{ marginBottom: '1rem' }}>
                            <label htmlFor="loginEmail" className="trf-label">Email</label>
                            <div style={{ position: 'relative' }}>
                                <Mail size={15} style={{ position: 'absolute', left: '0.75rem', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray-400)', pointerEvents: 'none' }} />
                                <input
                                    id="loginEmail" type="email" className="trf-input"
                                    style={{ paddingLeft: '2.3rem' }}
                                    placeholder="you@titanium-surgicalarts.com"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    required autoComplete="username"
                                />
                            </div>
                        </div>

                        <div style={{ marginBottom: '1.5rem' }}>
                            <label htmlFor="loginPass" className="trf-label">Password</label>
                            <div style={{ position: 'relative' }}>
                                <Lock size={15} style={{ position: 'absolute', left: '0.75rem', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray-400)', pointerEvents: 'none' }} />
                                <input
                                    id="loginPass" type={showPass ? 'text' : 'password'}
                                    className="trf-input"
                                    style={{ paddingLeft: '2.3rem', paddingRight: '2.8rem' }}
                                    placeholder="••••••••••"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    required autoComplete="current-password"
                                />
                                <button type="button" onClick={() => setShowPass(s => !s)}
                                    aria-label="Toggle password visibility"
                                    style={{ position: 'absolute', right: '0.75rem', top: '50%', transform: 'translateY(-50%)', border: 'none', background: 'none', cursor: 'pointer', color: 'var(--gray-400)', padding: 0 }}>
                                    {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
                                </button>
                            </div>
                        </div>

                        {error && (
                            <div style={{ background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', borderRadius: '6px', padding: '0.65rem 0.9rem', fontSize: '0.85rem', marginBottom: '1rem' }}>
                                {error}
                            </div>
                        )}

                        <button type="submit" className="trf-btn-submit" disabled={loading}>
                            {loading ? <><span className="trf-spinner" /> Signing in…</> : 'Sign In'}
                        </button>
                    </form>
                </div>

                <p style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                    Referring a patient?{' '}
                    <a href="/" style={{ color: 'var(--teal)', textDecoration: 'none', fontWeight: 700 }}>Submit a referral →</a>
                </p>
            </div>
        </div>
    );
}
